import { Component } from './component.js';
import { Label } from './label.js';

export class Switch extends Component {
  static defaultOptions = {
    componentName: 'Switch'
  };

  constructor (options) {
    super($.extend({}, Switch.defaultOptions, options));

    this.el.addClass('custom-control');
    this.el.addClass('custom-switch');

    this.checkbox = $(
      '<input type="checkbox" class="custom-control-input" checked="checked" id="checkbox"></input>'
    );
    this.el.append(this.checkbox);

    this.label = new Label();
    this.label.el.addClass('custom-control-label');
    this.label.el.attr('for', 'checkbox');
    this.add(this.label);
  }

  isOn () {
    return this.checkbox.prop('checked');
  }

  setOn (on, fireEvent) {
    this.checkbox.prop('checked', on);
    if (fireEvent) this.checkbox.trigger('change');
  }
}
